import axios from 'axios';
import { IIntegration } from '@signing-page/integrations/types/integration';
import { apolloClient } from '@signing-page/apollo';
import { stripeIntegrationQuery } from '@signing-page/api/integrations/graphql/integration.queries';
import { EFetchPolicy } from '@/api/types/enums/fetch-policy';

export default class StripeService {
  public static async getStripeIntegration(): Promise<IIntegration> {
    const {
      data: {
        document: { stripeIntegration },
      },
    } = await apolloClient.query({
      query: stripeIntegrationQuery,
      fetchPolicy: EFetchPolicy.NoCache,
    });
    return stripeIntegration;
  }

  public static async reportCharge(
    documentId: string,
    recipientId: string,
    authId: string,
    tokenId: string,
    email: string,
    amount: number
  ): Promise<boolean> {
    const body: FormData = new FormData();
    body.append('tokenid', tokenId);
    body.append('email', email);
    body.append('amount', amount.toString());

    const url = `/view/${documentId}/${recipientId}/${authId}/stripe`;
    const { data } = await axios.post(url, body);
    return data.status === 1;
  }
}
